import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-operations-and-instruments-related-to-ras',
  templateUrl: './operations-and-instruments-related-to-ras.component.html',
  styleUrls: ['./operations-and-instruments-related-to-ras.component.scss']
})
export class OperationsAndInstrumentsRelatedToRASComponent implements OnInit {

  @Input() data: { task: any };
  constructor(private readonly fb: FormBuilder) {}
  form: FormGroup = this.fb.group({
    othersInstruments: [],
  })

  ngOnInit(): void {
    const { task } = this.data;

    const values = task.data;
    if (values) {
      this.form.patchValue(values);
    }
  }

}
